import {getLocalProductClassList, localRead, localSave, setLocalProductClassList} from '../../utils/util'

import {
  addFormulation,
  addGoodClass,
  addPrecaution,
  addProductIngredientInfo,
  addProductSimple,
  addTechnology,
  changeGoodsdisplayType,
  copyProduct,
  delFormulation,
  delGoodClass,
  delPrecaution,
  delProductIndicatorsInfo,
  delTechnology,
  editAid,
  editGoodClass,
  editPrecaution,
  editProductIngredientInfo,
  editTechnology,
  editTransport,
  formatclass,
  getAidDetail,
  getAllProductClassList,
  getAllUnitList,
  getGoodClassDetail,
  getgoodsstatistics,
  getLicenseListByEntId,
  getPrecaution,
  getProductClassList,
  getProductFormulationList,
  getProductIndicators,
  getProductSimpleDetail,
  getSysProClassList,
  getTechnologyList,
  getTransport,
  getUnitList,
  migrateProduct,
  newGoodClass,
  setGoodSpecDefault,
  shelfgoods,
  sortProductIndicators
} from '../../services/product'

export default {
  state: {
    isnoshort: localRead('isnoshort') ? parseInt(localRead('isnoshort')) === 1 : true,
    guideList: [],
    productMenuActive: parseInt(localRead('productMenuActive')) || 0, // 显示的位置
    productMenuPath: localRead('productMenuPath') || '', // 商品路径
    productMenuTitle: localRead('productMenuTitle') || '', // 商品标题
    productName: localRead('productName') || '', // 商品名称
    isAddProduct: parseInt(localRead('isAddProduct')) || 1, // 添加商品1 详情2
    productId: parseInt(localRead('productId')) || 0, // 商品Id
    productVideoId: parseInt(localRead('productVideoId')) || 0, // 技术视频id
    productClassList: getLocalProductClassList(),
    productlistinfo: {
      selectindex: 0,
      pageNumber: 1
    },
    unitList: []
  },
  getters: {
    getmenulist: state => {
      let list = [{
        id: 0,
        name: '全部商品',
        jump_url: '/productlist/0',
        title: '全部商品',
        imgUrl: require('../../assets/common/ic_quanbu@2x.png'),
        classDesc: ''
      }]
      let a = state.productClassList.length ? list.concat(state.productClassList) : list
      return a
    },

    getproclasslist: state => {
      let list = [{
        id: 0,
        name: '全部',
        jump_url: '/productlist/0',
        title: '全部',
        imgUrl: require('../../assets/common/ic_quanbu@2x.png'),
        classDesc: ''
      }]

      let a = state.productClassList.length ? list.concat(state.productClassList) : list
      return a
    }
  },
  mutations: {
    setUnitList (state, unitList) {
      state.unitList = unitList
    },
    setproductlistinfo (state, productlistinfo) {
      state.productlistinfo = productlistinfo
    },
    setEditshort (state, isshort) {
      state.isnoshort = isshort
      localSave('isnoshort', isshort ? 1 : 0)
    },
    changeProductMenuActive (state, active) {
      state.productMenuActive = active
      localSave('productMenuActive', active)
    },
    changeProductMenuPath (state, path) {
      state.productMenuPath = path
      localSave('productMenuPath', path)
    },
    changeProductMenuTitle (state, title) {
      state.productMenuTitle = title
      localSave('productMenuTitle', title)
    },
    changeProductName (state, productName) {
      state.productName = productName
      localSave('productName', productName)
    },
    changeIsAddProduct (state, isAddProduct) {
      state.isAddProduct = isAddProduct
      localSave('isAddProduct', isAddProduct)
    },
    changeProductId (state, productId) {
      state.productId = productId
      localSave('productId', productId)
    },
    changeProductVideoId (state, productVideoId) {
      state.productVideoId = productVideoId
      localSave('productVideoId', productVideoId)
    },
    changeProductClassList (state, list) {
      state.productClassList = list
      setLocalProductClassList(list)
    },
    setProductGuildList (state, guideList) {
      state.guideList = guideList
    }
  },
  actions: {
    handleproductlistinfo ({commit}, productlistinfo) {
      return commit('setproductlistinfo', productlistinfo)
    },
    getSysProClassList (store) {
      return getSysProClassList()
    },
    getProductFormulationList (store) {
      return getProductFormulationList()
    },
    handleEditShort ({commit}, isshort) {
      commit('setEditshort', isshort)
    },
    handleProductGuildList ({commit}, guideList) {
      commit('setProductGuildList', guideList)
    },
    changeProductMenuActive ({commit}, productMenuPath) {
      commit('changeProductMenuActive', productMenuPath)
    },
    changeProductMenuPath ({commit}, productMenuPath) {
      commit('changeProductMenuPath', productMenuPath)
    },
    changeProductMenuTitle ({commit}, productMenuTitle) {
      commit('changeProductMenuTitle', productMenuTitle)
    },
    changeIsAddProduct ({commit}, isAddProduct) {
      commit('changeIsAddProduct', isAddProduct)
    },
    changeProductName ({commit}, productName) {
      commit('changeProductName', productName)
    },
    changeProductId ({commit}, productId) {
      commit('changeProductId', productId)
    },
    changeProductVideoId ({commit}, productVideoId) {
      commit('changeProductVideoId', productVideoId)
    },
    changeProductClassList ({commit}) {
      return new Promise((resolve, reject) => {
        getProductClassList().then(res => {
          if (res.code === 0) {
            let list = res.data
            let length = list.length
            let menuList = []
            for (let i = 0; i < length; i++) {
              let item = list[i]
              let obj = {
                id: item.classId,
                name: item.className,
                jump_url: '/productlist/' + item.classId,
                icon: item.classIcon || '',
                referenceStatus: item.referenceStatus || 0,
                title: item.className,
                imgUrl: (item.imgList && item.imgList.length) ? item.imgList[0].imgUrl : '',
                classDesc: item.classDesc
              }
              menuList.push(obj)
            }
            commit('changeProductClassList', menuList)
            resolve(res)
          } else {
            reject(res)
          }
        })
      })
    },
    getLicenseListByEntId (store, {enterpriseId, pageNum, type, classId, name}) {
      let params = {
        enterpriseId: enterpriseId,
        pageNum: pageNum,
        pageSize: 20,
        type: type
      }
      if (classId) {
        params.classId = classId
      }
      if (name) {
        params.name = name
      }
      return getLicenseListByEntId(params)
    },

    getTechnologyList (store, params) {
      return getTechnologyList(params)
    },

    addTradeappLicense (store, params) {
      // return addTradeappLicense(params)
    },
    addPrecaution (store, params) {
      return addPrecaution(params)
    },
    editPrecaution (store, {precautionId, params}) {
      return editPrecaution(precautionId, params)
    },

    getPrecaution (store, {goodsId}) {
      let params = {
        goodsId: goodsId
      }
      return getPrecaution(params)
    },
    delPrecaution (store, params) {
      return delPrecaution(params)
    },

    editAid (store, params) {
      return editAid(params)
    },
    getAidDetail (store, {goodsId}) {
      let params = {
        goodsId: goodsId
      }
      return getAidDetail(params)
    },
    editTransport (store, params) {
      return editTransport(params)
    },
    getTransport (store, {goodsId}) {
      let params = {
        goodsId: goodsId
      }
      return getTransport(params)
    },
    addGoodClass (store, params) {
      return addGoodClass(params)
    },
    editGoodClass (store, proClassinfo) {
      let classid = proClassinfo.id
      let params = proClassinfo.params
      return editGoodClass(classid, params)
    },
    delGoodClass (store, params) {
      return delGoodClass(params)
    },

    getGoodClassDetail (store, {classId}) {
      return getGoodClassDetail(classId)
    },

    addTechnology (store, params) {
      return addTechnology(params)
    },

    editTechnology (store, {technologyId, params}) {
      return editTechnology(technologyId, params)
    },

    delTechnology (store, params) {
      return delTechnology(params)
    },
    addProductIngredientInfo (store, params) {
      return addProductIngredientInfo(params)
    },
    editProductIngredientInfo (store, params) {
      return editProductIngredientInfo(params)
    },
    getProductIndicators (store, params) {
      return getProductIndicators(params)
    },
    delProductIndicatorsInfo (store, params) {
      return delProductIndicatorsInfo(params)
    },
    sortProductIndicators (store, params) {
      return sortProductIndicators(params)
    },
    setGoodSpecDefault (store, params) {
      return setGoodSpecDefault(params)
    },
    copyProduct (store, params) {
      return copyProduct(params)
    },
    addProductSimple (store, params) {
      return addProductSimple(params)
    },
    getProductSimpleDetail (store, goodsId) {
      return getProductSimpleDetail(goodsId)
    },
    newGoodClass (store, params) {
      return newGoodClass(params)
    },
    formatclass (store) {
      return formatclass()
    },
    shelfgoods (store, params) {
      return shelfgoods(params)
    },
    getAllProductClassList (store) {
      return getAllProductClassList()
    },
    getUnitList (store, formulationId) {
      return getUnitList(formulationId)
    },
    migrateProduct (store, params) {
      return migrateProduct(params)
    },
    changeGoodsdisplayType (store, params) {
      return changeGoodsdisplayType(params)
    },
    addFormulation (store, params) {
      return addFormulation(params)
    },
    delFormulation (store, params) {
      return delFormulation(params)
    },
    getgoodsstatistics (store, params) {
      return getgoodsstatistics(params)
    },
    getAllUnitList ({state, commit}) {
      if (state.unitList && state.unitList.length) {
        return new Promise((resolve, reject) => {
          resolve(state.unitList)
        })
      } else {
        return new Promise((resolve, reject) => {
          getAllUnitList().then(res => {
            if (res.code === 0) {
              let unitList = res.data
              commit('setUnitList', unitList)
              resolve(unitList)
            }
          })
        })
      }
    }
  }

}
